import { getAuthConfig } from '../config.js';

const getAmplifyConfig = ()=>{
    const config = getAuthConfig();
    const amplifyConfig = {
        Auth: {
            Cognito: {
                userPoolId: config.userPoolId,
                userPoolClientId: config.userPoolClientId,
                region: config.region,
                identityPoolId: config.identityPoolId,
                authenticationFlowType: config.authFlowType || 'USER_PASSWORD_AUTH',
                loginWith: {
                    username: true,
                    email: true
                },
                signUpVerificationMethod: 'code',
                userAttributes: {
                    email: {
                        required: true
                    }
                },
                allowGuestAccess: true,
                passwordFormat: {
                    minLength: 8,
                    requireLowercase: true,
                    requireUppercase: true,
                    requireNumbers: true,
                    requireSpecialCharacters: true
                }
            },
            ssr: config.ssr
        }
    };
    if (config.oauth) {
        amplifyConfig.Auth.Cognito.loginWith.oauth = {
            domain: config.oauth.domain,
            scopes: config.oauth.scope,
            redirectSignIn: config.oauth.redirectSignIn,
            redirectSignOut: config.oauth.redirectSignOut,
            responseType: config.oauth.responseType,
            providers: config.oauth.providers
        };
    }
    if (config.apiEndpoints) {
        amplifyConfig.API = {
            REST: config.apiEndpoints.reduce((acc, api)=>{
                acc[api.name] = {
                    endpoint: api.endpoint,
                    region: api.region
                };
                return acc;
            }, {})
        };
    }
    return amplifyConfig;
};

export { getAmplifyConfig };
//# sourceMappingURL=auth.config.js.map
